import { useEffect } from 'react';

export default function AuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const refreshToken = params.get('refreshToken');
    const user = params.get('user');
    const org = params.get('org');

    if (token && refreshToken && user && org) {
      localStorage.setItem('token', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('user', user);
      localStorage.setItem('org', org);

      try {
        const parsedOrg = JSON.parse(org);
        if (!parsedOrg.onboarded) {
          window.location.href = '/onboarding';
        } else {
          window.location.href = '/dashboard';
        }
      } catch {
        window.location.href = '/dashboard';
      }
    } else {
      window.location.href = '/';
    }
  }, []);

  return (
    <div style={{
      minHeight:'100vh',background:'#08080a',
      display:'flex',flexDirection:'column',
      alignItems:'center',justifyContent:'center',
      color:'#f0f0f2',fontFamily:'Inter,sans-serif',fontSize:'14px',gap:'12px'
    }}>
      <div style={{
        width:'8px',height:'8px',borderRadius:'50%',background:'#4f8ef7',
        animation:'pulse 1.4s infinite'
      }}/>
      <style>{`@keyframes pulse{0%,100%{opacity:1;transform:scale(1);}50%{opacity:0.3;transform:scale(0.7);}}`}</style>
      Setting up your workspace...
    </div>
  );
}